import React from 'react';
import { Box } from '@fiverr-private/theme';
import { TableProps } from '../../../../types';
import { TableRow } from './TableRow';

export const TableBody = <T,>({ table, emptyPage, noResults, onRowClick, onRowImpression }: TableProps<T>) => {
  const rows = table.getRowModel().rows;
  const isDataExists = !!table.getCoreRowModel().rows.length;

  const EmptyPageComponent = typeof emptyPage === 'function' ? emptyPage({}) : emptyPage;
  const NoResultsComponent = typeof noResults === 'function' ? noResults({}) : noResults;

  if (!isDataExists || !rows.length) {
    return (
      <Box as="tbody" boxSizing="borderBox">
        <Box as="tr" boxSizing="borderBox">
          <Box
            colSpan={table.getVisibleFlatColumns().length}
            as="td"
            boxSizing="borderBox"
            paddingY="6"
            paddingX="4"
            color="grey_1200"
            style={{ verticalAlign: 'middle' }}
          >
            {!isDataExists ? EmptyPageComponent : NoResultsComponent}
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box as="tbody" boxSizing="borderBox">
      {rows.map((row, idx) => (
        <TableRow
          key={row.id}
          row={row}
          onRowClick={onRowClick}
          onRowImpression={onRowImpression}
          borderBottomWidth={idx === rows.length - 1 ? undefined : 'sm'}
        />
      ))}
    </Box>
  );
};
